var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 2H10.25C10.3875 2 10.5 2.1125 10.5 2.25V3.5H5.5V2.25C5.5 2.1125 5.6125 2 5.75 2ZM4 2.25V3.5H2C0.896875 3.5 0 4.39687 0 5.5V8.5H11.2563C12.2656 7.27812 13.7906 6.5 15.5 6.5C15.6687 6.5 15.8344 6.50625 16 6.52187V5.5C16 4.39687 15.1031 3.5 14 3.5H12V2.25C12 1.28438 11.2156 0.5 10.25 0.5H5.75C4.78438 0.5 4 1.28438 4 2.25ZM10 11.5H7C6.44688 11.5 6 11.0531 6 10.5V9.5H0V13.5C0 14.6031 0.896875 15.5 2 15.5H11.2563C10.4719 14.55 10 13.3281 10 12C10 11.8313 10.0063 11.6656 10.0219 11.5H10ZM20 12C20 10.8065 19.5259 9.66193 18.682 8.81802C17.8381 7.97411 16.6935 7.5 15.5 7.5C14.3065 7.5 13.1619 7.97411 12.318 8.81802C11.4741 9.66193 11 10.8065 11 12C11 13.1935 11.4741 14.3381 12.318 15.182C13.1619 16.0259 14.3065 16.5 15.5 16.5C16.6935 16.5 17.8381 16.0259 18.682 15.182C19.5259 14.3381 20 13.1935 20 12ZM15.5 9.5C15.775 9.5 16 9.725 16 10V11.5H17C17.275 11.5 17.5 11.725 17.5 12C17.5 12.275 17.275 12.5 17 12.5H15.5C15.225 12.5 15 12.275 15 12V10C15 9.725 15.225 9.5 15.5 9.5Z",
    fill: "#FFB142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTime);
export default __webpack_public_path__ + "static/media/business-time.377e9f6ef95b054276ffaa24ac09bb60.svg";
export { ForwardRef as ReactComponent };